<block-ui [delayStart]="0" [delayStop]="0" [template]="blockTemplate" [class]="template">
  <div class="authentication-wrapper authentication-3">
    <div class="authentication-inner">
      <!-- Side container -->
      <!-- Do not display the container on extra small, small and medium screens -->
      <div class="d-none d-lg-flex col-lg-8 align-items-center ui-bg-cover ui-bg-overlay-container p-5"
        [style.backgroundImage]="'url('+ imagen +')'" style="background-size: cover;">
        <div class="dejarVer">
        </div>
        <div class="ui-bg-overlay bg-dark opacity-50"></div>
        <!-- Text -->
        <div class="w-100 text-white px-5 container-text">
          <h1 class="bienvenidoTitulo">BIENVENIDO A<br>ATLAS CONMIGO</h1>
          <a class="bienvenidoCuerpo">
            Un portal diseñado para que nuestros clientes y socios de negocios hagan uso de nuestros
            servicios
            en línea.
          </a>
        </div>

        <!-- /.Text -->
      </div>
      <div class="d-flex col-lg-4 align-items-center bg-white p-5">
        <!-- Inner container -->
        <!-- Have to add `.d-flex` to control width via `.col-*` classes -->
        <div class="d-flex col-sm-7 col-md-5 col-lg-12 px-0 px-xl-4 mx-auto">
          <div class="w-100">

            <!-- Logo -->
            <div class="d-flex justify-content-center align-items-center">
              <div class="ui-w-60">
                <div class="w-100 position-relative">
                  <img src="assets/img/icono-atlas.png" height="60px">
                </div>
              </div>
            </div>
            <!-- / Logo -->
            <h5 class="slogan">Atlas Conmigo</h5>
            <h6 class="slogan">Reasegurador</h6>
            <div>
              <form class="my-4" [formGroup]="todoFormulario">
                <div class="row justify-content-center align-items-center">
                  <div class="row justify-content-left">
                    <mat-form-field class="col-md-6 mt-4 usuario-field">
                      <mat-label>NIP</mat-label>
                      <input type="tel" matInput formControlName="NIP">
                      @if (todoFormulario.get('NIP').hasError('required')) {
                        <mat-error>
                          El campo es obligatorio
                        </mat-error>
                      }
                    </mat-form-field>
                    <mat-form-field class="col-md-6 mt-4 usuario-field">
                      <mat-label>Usuario</mat-label>
                      <input type="text" minlength="4" maxlength="8" matInput
                        formControlName="Usuario">
                        <span matSuffix class="d-flex align-items-center">
                          @if (usuarioValido) {
                            @if (usuarioValido.pending && !todoFormulario.get('Usuario')?.hasError('pattern')) {
                              <mat-icon class="fa-spin">sync</mat-icon>
                            }

                            @if (!usuarioValido.pending && (validacionUsuario != '' || todoFormulario.get('Usuario')?.hasError('pattern'))) {
                              <mat-icon
                                class="errors"
                                [matTooltip]="validacionUsuario || 'El campo debe ser alfanumérico'">
                                error_outline
                              </mat-icon>
                            }

                            @if (usuarioValido.is && !usuarioValido.pending && todoFormulario.get('Usuario')?.valid && validacionUsuario == '') {
                              <mat-icon class="check-valido">check_circle</mat-icon>
                            }
                          }
                        </span>

                        @if (todoFormulario.get('Usuario')?.hasError('required')) {
                          <mat-error>
                            El campo es obligatorio
                          </mat-error>
                        }

                        @if (todoFormulario.get('Usuario')?.hasError('pattern') && !todoFormulario.get('Usuario')?.hasError('required')) {
                          <mat-error>
                            No se permiten caracteres especiales
                          </mat-error>
                        }

                        @if (todoFormulario.get('Usuario')?.hasError('minlengthCustom') && !todoFormulario.get('Usuario')?.hasError('pattern')) {
                          <mat-error>
                            Usuario invalido
                          </mat-error>
                        }

                        @if (todoFormulario.get('Usuario')?.hasError('maxlengthCustom') && !todoFormulario.get('Usuario')?.hasError('pattern')) {
                          <mat-error>
                            Usuario invalido
                          </mat-error>
                        }

                        @if (todoFormulario.get('Usuario')?.hasError('exists') && !todoFormulario.get('Usuario')?.hasError('pattern')) {
                          <mat-error>
                            Usuario invalido
                          </mat-error>
                        }

                        @if (todoFormulario.get('Usuario')?.hasError('customError') && !todoFormulario.get('Usuario')?.hasError('pattern')) {
                          <mat-error>
                            Usuario invalido
                          </mat-error>
                        }
                        <!-- <mat-error
                        *ngIf="validacionUsuario||!todoFormulario.get('Usuario').hasError('required')">
                        Usuario invalido
                      </mat-error> -->
                    </mat-form-field>
                    <mat-form-field class="col-md-6 my-auto"
                      [ngClass]="generaErrorPasswordForm ? 'mat-focused' : ''">
                      <mat-label>Contraseña</mat-label>
                      <input matInput #password formControlName="Password"
                        [type]="hide ? 'password' : 'text'">
                        <span matSuffix class="d-flex align-items-center">
                          <button mat-icon-button matSuffix (click)="hide = !hide"
                            [attr.aria-label]="'Hide password'" [attr.aria-pressed]="hide">
                            <mat-icon>{{hide ? 'visibility_off' : 'visibility'}}</mat-icon>
                          </button>
                          <mat-icon id="iconPass" class="mt-1"
                          [ngClass]="{'d-none': validandoPassword || generaErrorPasswordForm }">check_circle</mat-icon>
                          @if (validandoPassword) {
                            <mat-icon class="fa-spin">sync</mat-icon>
                          }
                          <mat-icon class="errors" [ngClass]="{'d-none': !generaErrorPasswordForm }"
                          >error_outline</mat-icon>
                        </span>
                        @if (todoFormulario.get('Password').hasError('required')) {
                          <mat-error>
                            El campo es obligatorio
                          </mat-error>
                        }
                        @if (todoFormulario.get('Password')?.hasError('formatoIncorrecto')) {
                          <mat-error>
                            La contraseña tiene un formato incorrecto
                          </mat-error>
                        }
                      </mat-form-field>

                      <mat-form-field class="col-md-6 my-auto">
                        <mat-label>Confirma Contraseña</mat-label>
                        <input matInput formControlName="ConfirmaPassword"
                          [type]="hide ? 'password' : 'text'">
                          <button type="button" mat-icon-button matSuffix (click)="hide = !hide"
                            [attr.aria-label]="'Hide password'" [attr.aria-pressed]="hide">
                            <mat-icon>{{hide ? 'visibility_off' : 'visibility'}}</mat-icon>
                          </button>
                          @if (todoFormulario.get('ConfirmaPassword').hasError('required')) {
                            <mat-error
                              >
                              El campo es obligatorio
                            </mat-error>
                          }
                          @if (todoFormulario.get('ConfirmaPassword').hasError('match')) {
                            <mat-error>
                              Las contraseñas no coinciden
                            </mat-error>
                          }
                        </mat-form-field>


                        <mat-form-field class="col-md-6 mt-4">
                          <mat-label>Clave de Reasegurador</mat-label>
                          <input type="text" matInput formControlName="Cuenta">
                          @if (todoFormulario.get('Cuenta').hasError('required')) {
                            <mat-error>
                              El campo es obligatorio
                            </mat-error>
                          }
                        </mat-form-field>
                        <mat-form-field class="col-md-6 mt-4">
                          <mat-label>Alias o sobrenombre</mat-label>
                          <input type="text" matInput formControlName="Alias">
                          @if (todoFormulario.get('Alias').hasError('required')) {
                            <mat-error>
                              El campo es obligatorio
                            </mat-error>
                          }
                        </mat-form-field>

                        <mat-form-field class="col-md-10">
                          <mat-label>Teléfono celular</mat-label>
                          <span matTextPrefix>+ &nbsp;</span>
                          <input type="number" matInput formControlName="Telefono">
                          <span matSuffix class="icon-group">
                            <button mat-icon-button type="button" matSuffix>
                              @if (validandoTelefono) {
                                <mat-icon
                                class="check-valido">check_circle</mat-icon>
                              }
                              @if (!validandoTelefono) {
                                <mat-icon>error_outline</mat-icon>
                              }
                            </button>
                          </span>

                          @if (todoFormulario.get('Telefono').hasError('required')) {
                            <mat-error>
                              El campo es obligatorio
                            </mat-error>
                          }
                          @if (todoFormulario.get('Telefono').hasError('pattern')) {
                            <mat-error>
                              Se requieren almenos 12 digitos, iniciando
                              con el codigo del país 52(México)
                            </mat-error>
                          }

                        </mat-form-field>
                        <div class="col-md-2">
                          @if (!validandoTelefono) {
                            <button mat-raised-button color="primary"
                              [disabled]="!todoFormulario.get('Telefono').valid"
                            (click)="ValidarTelefono()">Verificar</button>
                          }
                        </div>

                        <mat-form-field class="col-md-10 mt-4">
                          <mat-label>Email</mat-label>
                          <input type="text" matInput formControlName="Email">
                          <button mat-icon-button type="button" matSuffix>
                            @if (validandoCorreo) {
                              <mat-icon
                              class="check-valido">check_circle</mat-icon>
                            }
                            @if (!validandoCorreo) {
                              <mat-icon>error_outline</mat-icon>
                            }
                          </button>
                          @if (todoFormulario.get('Email').hasError('required')) {
                            <mat-error>
                              El campo es obligatorio
                            </mat-error>
                          }
                          @if (todoFormulario.get('Email').hasError('email') || todoFormulario.get('Email').hasError('pattern')) {
                            <mat-error
                              >
                              El campo email debe tener un formato valido
                            </mat-error>
                          }
                        </mat-form-field>
                        <div class="col-md-2">
                          @if (!validandoCorreo) {
                            <button mat-raised-button color="primary"
                              [disabled]="!todoFormulario.get('Email').valid"
                            (click)="ValidarCorreo()">Verificar</button>
                          }
                        </div>
                        <mat-form-field class="col-md-12 mt-4">
                          <mat-label>Pregunta Secreta</mat-label>
                          <mat-select formControlName="IdPregunta">
                            @for (preguntas of catPreguntas; track preguntas) {
                              <mat-option
                                [value]="preguntas.Value">
                                {{preguntas.Text}}
                              </mat-option>
                            }
                          </mat-select>
                        </mat-form-field>
                        <mat-form-field class="col-md-12 mt-4">
                          <mat-label>Respuesta</mat-label>
                          <input type="text" matInput formControlName="Respuesta">
                          @if (todoFormulario.get('Respuesta').hasError('required')) {
                            <mat-error>
                              El campo es obligatorio
                            </mat-error>
                          }
                        </mat-form-field>

                        <mat-form-field class="col-md-12 mt-4">
                          <mat-label>Nacionalidad</mat-label>
                          <mat-select formControlName="Nacionalidad">
                            <mat-option value="1">MEXICANO</mat-option>
                            <mat-option value="2">EXTRANJERO</mat-option>
                          </mat-select>
                        </mat-form-field>



                        <mat-form-field class="col-md-12 mt-4">
                          <mat-label>Razón Social</mat-label>
                          <input type="text" matInput formControlName="RazonSocial">
                          @if (todoFormulario.get('RazonSocial').hasError('required')) {
                            <mat-error>
                              El campo es obligatorio
                            </mat-error>
                          }
                        </mat-form-field>



                        @if (todoFormulario.get('Nacionalidad').value != null && todoFormulario.get('Nacionalidad').value != '') {
                          <mat-form-field class="col-md-12 mt-4"
                            >
                            <mat-label>{{ todoFormulario.get('Nacionalidad').value === '1' ? 'RFC' :
                              'RGRE'
                            }}</mat-label>
                            <input type="text" matInput formControlName="RFC" maxlength="13">
                            @if (todoFormulario.get('RFC').hasError('required')) {
                              <mat-error>
                                El campo es obligatorio
                              </mat-error>
                            }
                            @if (todoFormulario.get('RFC').hasError('pattern')) {
                              <mat-error>
                                El {{ todoFormulario.get('Nacionalidad').value === '1' ? 'RFC' :
                                'RGRE'}}
                                debe tener un formato valido
                              </mat-error>
                            }
                          </mat-form-field>
                        }

                      </div>
                    </div>
                    <div class="d-flex justify-content-between align-items-center m-0 my-4">
                      <button mat-raised-button color="primary" (click)="registrar()"
                        [disabled]="!todoFormulario.valid  || !usuarioValido.is">
                        @if (!loading) {
                          <span>REGISTRARSE</span>
                        }
                        @if (loading) {
                          <span><i class="fas fa-sync fa-spin"></i> Cargando...</span>
                        }
                      </button>

                      <button class="m-2" mat-raised-button color="primary"
                      (click)="regresar()">Regresar</button>

                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </block-ui>